<template>
    <div class="add">
        <Head-view :showStyle="'1'"></Head-view>
        <div class="main">
            <div class="breadcrumb">新建机构</div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="instMsg">机构信息</div>
                    <div class="commRowstyle logo">
                        <div class="inpTitle logoSplick">
                            <span>*</span> logo
                        </div>
                        <div class="addHeadImg">
                            <input
                                type="file"
                                name="file"
                                ref="headImgRef"
                                accept="image/*,.jpg,.png,.git,.webp,.svg,"
                                @change="uploadHeadImg()"
                                v-if="!imgHead"
                            />
                            <img :src="imgHead" v-if="imgHead" alt="" />
                            <div
                                class="delHeadImg"
                                v-if="imgHead"
                                @click="delHeadImg()"
                            >
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div class="tipSize" v-if="!editFlag">
                            (建议尺寸为256*256)
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span> 机构名称</div>
                        <div class="inpFrom">
                            <el-input
                                v-model="instMsg.name"
                                placeholder="请输入"
                                @blur="trimBoth('name', instMsg.name)"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span> 所在城市
                        </div>
                        <div class="inpFrom">
                            <el-cascader
                                v-model="value"
                                placeholder="请选择"
                                @change="handleChange"
                                :props="props"
                                :options="cityOptions"
                            ></el-cascader>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span> 详细地址
                        </div>
                        <div class="inpFrom">
                            <el-input
                                @blur="trimBoth('address', instMsg.address)"
                                v-model="instMsg.address"
                                placeholder="请输入"
                            ></el-input>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span> 负责人姓名</div>
                        <div class="inpFrom">
                            <el-input
                                @blur="trimBoth('director', instMsg.director)"
                                v-model="instMsg.director"
                                placeholder="请输入"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span> 联系电话
                        </div>
                        <div class="inpFrom">
                            <el-input
                                text="number"
                                @blur="trimBoth('phone', instMsg.phone)"
                                v-model="instMsg.phone"
                                placeholder="请输入"
                                maxlength="11"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">账号有效期</div>
                        <div class="inpFrom">
                            <el-date-picker
                                v-model="expireDate"
                                type="date"
                                placeholder="选择日期"
                                ref="expireRef"
                                @change="isExpireDate"
                            >
                            </el-date-picker>
                        </div>
                        <div class="tip">(不填即为永久有效)</div>
                    </div>
                    <div class="commRowstyle marginTop_30 instNumber">
                        <div class="inpTitle"><span>*</span> 机构代号</div>
                        <div
                            class="inpFrom"
                            :class="[repeatErr ? 'inpColorRed' : 'codeFont']"
                        >
                            <el-input
                                @blur="trimBoth('code', instMsg.code)"
                                v-model="instMsg.code"
                                placeholder="请输入"
                                v-if="!editFlag"
                                maxlength="5"
                                @focus="focusReplace()"
                            ></el-input>
                            <span v-if="editFlag">{{
                                instMsg.adminStaffNumber
                            }}</span>
                        </div>
                        <div :class="[repeatErr ? 'tipBox' : '']">
                            <div class="numError" v-if="repeatErr">
                                该代号已使用
                            </div>
                            <div class="tip" v-if="!editFlag">
                                (1-5个字符的大写字母或数字)
                            </div>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 userNumber">
                        <span>超级管理员账号：</span
                        ><span v-if="instMsg.code != ''"
                            >{{ instMsg.code }}01</span
                        >
                    </div>
                    <div class="commRowstyle" v-if="!editFlag">
                        <div class="inpTitle">初始密码</div>
                        <div class="inpFrom">
                            <el-input
                                @blur="trimBoth('password', instMsg.password)"
                                v-model="instMsg.password"
                                placeholder="888888"
                            ></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            <div class="btn">
                <div class="commBtn closeBtn" @click="backClose()">取消</div>
                <div class="commBtn successBtn" @click="preservationData()">
                    保存
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getCookie } from "../../untils/tools";
export default {
    name: "add",
    data() {
        return {
            imgHead: "",
            fileImg: "",
            repeatErr: false,

            instMsg: {
                name: "",
                code: "",
                password: "",
                phone: "",
                address: "",
                director: "",
            },

            value: [],

            cityCode: "",
            cityOptions: [],

            expireDate: "",

            editTitle: "新建机构",
            editFlag: false, //是否为编辑

            props: {
                lazy: true,
                lazyLoad: (node, resolve) => {
                    let val = "";
                    const { level } = node; // node 节点数据
                    let cityArr = [];
                    let type = level == 0 ? "0" : node.value; // 0 代表第一次请求
                    if (type > 0) val = node.value;
                    if (this.cityFlag && this.cityFlagNum == val) {
                        // let key = String(val).substr(1, 1) - 1
                        // document.querySelector('.el-cascader-menu__list').childNodes[key].childNodes[1].setAttribute('class', 'el-icon-arrow-right el-cascader-node__postfix')
                        return;
                    }
                    this.getCityInfo(type, val)
                        .then((res) => {
                            if (res.code >= 0) {
                                res.data.map((item) => {
                                    let area = {
                                        value: item.code,
                                        label: item.name,
                                        leaf: node.level >= 1,
                                    };
                                    cityArr.push(area);
                                });
                                resolve(cityArr);
                            } else {
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                },
            },
            fullscreenLoading: false,

            cityFlag: false,
            cityFlagNum: "",
        };
    },

    components: {
        HeadView,
    },

    created() {},

    mounted() {
        if (this.$route.query.id) {
            //编辑
            this.editFlag = true;
            this.editTitle = "编辑机构";
            this.institutionMsgInfo(this.$route.query.id);
        }
    },

    methods: {
        getCityInfo(type = 0, val) {
            let data = {
                token: getCookie(),
            };
            if (type == 0) {
                return this.request.post(
                    this.commUrl + "getProvinceList",
                    data
                );
            } else {
                let checkData = {
                    token: getCookie(),
                    provinceCode: val,
                };
                return this.request.post(
                    this.commUrl + "getCityList",
                    checkData
                );
            }
        },

        institutionMsgInfo(insId) {
            let data = {
                token: getCookie(),
                insId: insId,
            };
            this.request
                .post(this.baseUrl + "Institution/getInsDetail", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.$nextTick(() => {
                            let cityValue =
                                String(res.data.cityCode).substr(0, 2) +
                                "0000000000";
                            this.instMsg = res.data;
                            this.expireDate = res.data.expireDate;
                            this.imgHead = res.data.logo;
                            this.cityCode = res.data.cityCode;
                            this.showCity(cityValue); //城市回显
                        });
                    }
                });
        },

        showCity(code) {
            this.value = [Number(code), this.cityCode];

            this.getCityInfo(0).then((res) => {
                if (res.code == 0) {
                    let dataArr = [];
                    res.data.forEach((item) => {
                        dataArr.push({
                            value: item.code,
                            label: item.name,
                            children: [],
                            leaf: false,
                        });
                    });

                    this.getCityInfo(1, code).then((val) => {
                        dataArr.forEach((once, key) => {
                            val.data.forEach((value) => {
                                let codeNum =
                                    String(value.code).substr(0, 2) +
                                    "0000000000";
                                if (codeNum == once.value) {
                                    dataArr[key]["children"].push({
                                        value: value.code,
                                        label: value.name,
                                        leaf: true,
                                    });
                                }
                            });
                        });
                        this.cityOptions = dataArr;
                        this.cityFlag = true;
                        this.cityFlagNum = this.value[0];
                    });
                }
            });
        },

        handleChange(e) {
            if (typeof e != "string") {
                this.cityCode = e[1];
                if (this.cityFlagNum != e[0]) {
                    this.cityFlag = false;
                }
            }
        },

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "name":
                    this.instMsg.name = trimVal;
                    break;
                case "address":
                    this.instMsg.address = trimVal;
                    break;
                case "password":
                    this.instMsg.password = trimVal;
                    break;
                case "director":
                    this.instMsg.director = trimVal;
                    break;
                case "phone":
                    var regexp = /[^\d，,]]*/g;
                    this.instMsg.phone = val.replace(regexp, "");
                    break;
                case "code":
                    if (trimVal.length > 5) {
                        trimVal = trimVal.substr(0, 5);
                    }

                    this.instMsg.code = trimVal.toUpperCase();

                    break;
                default:
                    break;
            }
        },

        uploadHeadImg() {
            //头像
            let _this = this;
            let file = this.$refs.headImgRef.files[0];
            this.fileImg = this.$refs.headImgRef.files[0];
            let imgData = new FileReader();
            imgData.readAsDataURL(file);
            imgData.onload = function (ev) {
                _this.imgHead = this.result;
            };
        },

        delHeadImg() {
            //清空头像
            this.imgHead = "";
            this.fileImg = "";
        },

        preservationData() {
            //保存信息
            if (
                !this.instMsg.name ||
                !this.instMsg.phone ||
                !this.instMsg.address ||
                !this.cityCode ||
                !this.instMsg.director ||
                !this.imgHead
            ) {
                return this.$message({
                    type: "warning",
                    message: "带有 * 标志的均不能为空",
                });
            }

            if (this.editFlag) {
                if (!this.instMsg.code) {
                    return this.$message({
                        type: "warning",
                        message: "带有 * 标志的均不能为空",
                    });
                }
            }

            const loading = this.$loading({
                lock: true,
                text: "保存信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            this.instMsg.password = this.instMsg.password
                ? this.instMsg.password
                : "888888";
            let timeEnd = "";
            if (this.expireDate && typeof this.expireDate == "object") {
                timeEnd =
                    this.expireDate.getFullYear() +
                    "-" +
                    ((this.expireDate.getMonth() + 1) < 10
                        ? "0" + (this.expireDate.getMonth() + 1)
                        : (this.expireDate.getMonth() + 1)) +
                    "-" +
                    (this.expireDate.getDate() < 10
                        ? "0" + this.expireDate.getDate()
                        : this.expireDate.getDate());
            }
            if (this.imgHead.indexOf("https") >= 0 && this.editFlag) {
                this.upDataInst("", timeEnd, loading);
                return;
            }
            let formData =  new FormData()
            formData.append('file', this.fileImg)
            formData.append('token', this.getCookie())

            this.request
                .post(this.commUrl + "uploadFile", formData)
                .then((resUrl) => {
                    if (resUrl.code == 0) {
                        let data = {
                            token: getCookie(),
                            name: this.instMsg.name,
                            logo: resUrl.data.url,
                            code: this.instMsg.code,
                            cityCode: this.cityCode,
                            director: this.instMsg.director,
                            phone: this.instMsg.phone,
                            address: this.instMsg.address,
                            expireDate: timeEnd,
                            password: this.instMsg.password,
                        };
                        if (this.$route.query.id) {
                            this.upDataInst(resUrl.data.url, timeEnd, loading);
                            return;
                        }
                        this.request
                            .post(this.baseUrl + "Institution/addIns", data)
                            .then((res) => {
                                if (res.code == 0) {
                                    if (res.data.result) {
                                        loading.close();
                                        this.$message({
                                            type: "success",
                                            message: "保存成功",
                                        });
                                        setTimeout(() => {
                                            this.$message.closeAll();
                                            this.$router.push(
                                                "/institutionList"
                                            );
                                        }, 1000);
                                    } else {
                                        this.repeatErr = true;
                                        this.$message({
                                            type: "warning",
                                            message: res.msg,
                                        });
                                    }
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.msg,
                                    });
                                }
                                loading.close();
                            })
                            .catch((err) => {
                                this.$message({
                                    type: "error",
                                    message: err,
                                });
                            });
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: resUrl.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        upDataInst(data, timeEnd, loading) {
            //更新信息
            let upData = {
                token: getCookie(),
                name: this.instMsg.name,
                logo: data == "" ? this.imgHead : data,
                cityCode: this.cityCode,
                insId: this.$route.query.id,
                director: this.instMsg.director,
                phone: this.instMsg.phone,
                address: this.instMsg.address,
                expireDate: timeEnd,
            };
            this.request
                .post(this.baseUrl + "/Institution/updateIns", upData)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                    loading.close();
                    setTimeout(() => {
                        this.$message.closeAll();
                        this.$router.push("/institutionList");
                    }, 1000);
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        isExpireDate(e) {
            if (e == null) return
            let val = new Date(this.expireDate).getTime();
            if (val < new Date().getTime()) {
                this.expireDate = "";
                return this.$message({
                    type: "warning",
                    message: "请选择大于当前时间的日期",
                });
            }
        },

        focusReplace() {
            this.repeatErr = false;
        },

        backClose() {
            this.$router.replace("/institutionList");
        },
    },
};
</script>

<style lang="less" scoped>
.add {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .commRowstyle {
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 107px;
                color: rgba(84, 85, 86, 1);
                font-size: 14px;
                line-height: 40px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;

                input {
                    width: 100%;
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .logo {
            margin-top: 12px;
            .logoSplick {
                height: 60px;
                line-height: 60px;
            }
            .addHeadImg {
                position: relative;
                width: 60px;
                height: 60px;
                border: 1px solid rgba(216, 220, 230, 1);
                background: url("../../assets/addInst/addBtn.png") no-repeat
                    center center;
                overflow: hidden;
                input {
                    opacity: 0;
                    width: 100%;
                    height: 100%;
                }
                img {
                    width: 100%;
                }
                .delHeadImg {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                }
            }
            .addHeadImg:hover .delHeadImg {
                display: block;
            }

            .tipSize {
                padding-left: 15px;
                line-height: 60px;
                color: rgba(144, 147, 153, 1);
                font-size: 13px;
                font-weight: 400;
            }
        }

        .tip {
            padding-top: 21px;
            padding-left: 15px;
            color: rgba(144, 147, 153, 1);
            font-size: 13px;
            height: 19px;
            font-weight: 400;
            text-align: left;
        }

        .userNumber {
            padding-bottom: 10px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
            font-weight: 500;
        }

        .tipBox {
            padding-left: 15px;
            .numError {
                padding-left: 18px;
                height: 20px;
                line-height: 17px;
                color: rgba(250, 85, 85, 1);
                font-size: 12px;
                font-weight: 400;
                background: url("../../assets/addInst/tip.png") no-repeat 0 1px;
                background-size: 16px 16px;
            }

            > .tip {
                padding: 0;
                padding-top: 1px;
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }
}

/deep/ .el-input__inner {
    width: 256px;
}

.inpColorRed {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}
</style>